import { Dtos } from "@inrev/common";
import { Option } from "@inrev/core";
import { getNestedValue, getPartialFieldPaths } from "../../../../../utils/schema-fields";
import { metadataSchemaForAccountDetail } from "../../historySchemaForAccountDetail";

type AccountHistoryData = Pick<Dtos.SuretyAccount.Get.Response, "modelSize"> & {
	history: Dtos.SuretyAccount.Metadata.Get.Response;
};

const IndividualDto = Dtos.Individual.Get.Response.schema;

export function hasEmptyIndividuals(individuals: Dtos.Individual.Get.Response[]): boolean {
	return individuals.length === 0;
}

export function hasPartialIndividuals(individuals: Dtos.Individual.Get.Response[]): boolean {
	const owners = individuals.filter((individual) => individual.type === "owner");
	return owners.some((owner) => {
		const partialPaths = getPartialFieldPaths(IndividualDto, owner);
		return partialPaths.some((fieldPath) => Option.isNone(getNestedValue(owner, fieldPath)));
	});
}

export function hasPartialHistory(
	account: AccountHistoryData,
	showContractHistory: boolean,
): boolean {
	if (account.modelSize == null) return false;
	const historySchema = metadataSchemaForAccountDetail(account.modelSize, showContractHistory);
	const partialPaths = getPartialFieldPaths(historySchema, account.history);
	return partialPaths.some((fieldPath) =>
		Option.isNone(getNestedValue(account.history, fieldPath)),
	);
}

export function isWipMissing(
	latestWipStatement: Dtos.WipStatement.Get.Response | null | undefined,
	modelSize: AccountHistoryData["modelSize"],
): boolean {
	if (modelSize == null || modelSize === "small") return false;
	return Option.isNone(latestWipStatement);
}

export function hasPartialWip(
	latestWipStatement: Dtos.WipStatement.Get.Response | null | undefined,
	modelSize: AccountHistoryData["modelSize"],
): boolean {
	if (modelSize == null || modelSize === "small") return false;
	if (Option.isNone(latestWipStatement)) return false;
	if (Option.isNone(latestWipStatement.projectBacklogCost)) return true;
	if (modelSize === "large" && Option.isNone(latestWipStatement.projectBacklogGrossProfit))
		return true;
	return false;
}
